import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

if ($('.home-hero-swiper').length) {

	// The hero image is static; only the text below it swipes, and only on mobile,
	// where `#home-hero .home-hero-swiper` is the visible layout. Above `md` the
	// container is `display: none`.
	//
	// Swiper stays enabled at every width rather than being disabled by a
	// breakpoint: the pagination module only renders its bullets during init, so a
	// Swiper that inits disabled never gets bullets, even after it re-enables.
	// The cost of always initialising is that a load at desktop width measures the
	// hidden slides as 0 wide, so re-measure whenever the mobile layout is the one
	// on screen.
	const homePageSwiper = new Swiper('.home-hero-swiper', {
		autoHeight: true,
		observer: true,
		observeParents: true,
		pagination: {
			clickable: true,
			el: '.home-hero-swiper .swiper-pagination',
		},
	});

	$(window).on('resize', function() {
		if ($(window).width() < 768) {
			homePageSwiper.update();
		}
	});
}
